import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import PaymentMethodSelection from 'frontend-payments/components/payment/method-selection';
import type AuthenticatedPaymentMethodController from 'frontend-payments/controllers/authenticated/payment-method';
import { contextualPageTitle } from 'frontend-utils';

interface AuthenticatedPaymentMethodSignature {
  controller: AuthenticatedPaymentMethodController;
}

export default class AuthenticatedPaymentMethod extends Component<AuthenticatedPaymentMethodSignature> {
  @service declare accountSwitcher: Services['account-switcher'];

  <template>
    {{pageTitle
      (contextualPageTitle
        (t "payments.payment_details.payment_method")
        this.accountSwitcher.currentAccount.name
      )
    }}

    {{#if @controller.model.transactions}}
      <PaymentMethodSelection
        @account={{@controller.account}}
        @isAccountLoading={{@controller.isAccountRequestLoading}}
        @onBack={{@controller.onBack}}
        @paymentDetails={{@controller.model.paymentDetails}}
        @transactions={{@controller.model.transactions}}
      />
    {{/if}}
  </template>
}
